// Call Partnerships
import { apiAuth } from '../../utils/hooks';

const patchAccount = (accountId, updatedAccount) => {
    return apiAuth()
        .patch(`/account/${accountId}`, updatedAccount)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getMyUser = () => {
    return apiAuth()
        .get('/account/me/user/me')
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const patchMyUser = (updatedUser) => {
    return apiAuth()
        .patch('/account/me/user/me', updatedUser)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export { patchAccount, patchMyUser, getMyUser };
